import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import "./chatpopup.css";
import ChatTable from "./chattable";
const ChatPopup = (props) => {
    const [modal, setModal] = useState(true);
    const [unsentChats, setUnsentChats] = useState(props.data);
    const toggle = () => setModal(!modal);

    const handleClose = () => {
        props.unsentChatCondition(false);
    };
    return (
        <div>
            <Modal
                isOpen={modal}
                onClosed={() => {
                    handleClose();
                }}
                toggle={toggle}
                className="chatpopup"
            >
                <ModalHeader>Chats Not Sent
                    <button
                        type="button"
                        onClick={toggle}
                        data-dismiss="modal"
                        aria-label="Close"
                        className="close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </ModalHeader>
                <ModalBody>
                    <ChatTable unsentChats={unsentChats} />
                </ModalBody>
            </Modal>
        </div>
    );
};

export default ChatPopup;
